// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__fkrry","text":"Loader_text__9kvIt","loader":"Loader_loader__MmKLJ","rotation":"Loader_rotation__Bmv4Z"};